module.exports = __webpack_public_path__ + "f1c7d3d38d8f489f70a05d072078188b.glb";